import axios from './http'
import qs from 'qs'
const questionnaire = {

    /**
     * 获取信息
     * @param chooseLang
     */
    getInfo(chooseLang) {
        return axios.get(`/urnature/MOMENTAASSESSMENTSERVICE/free/gate/momentaryassessment/main/getMessageByChoose?chooseLang=${chooseLang}`)
    },

    /**
     * 添加用户详细信息
     */
    addUserDetail() {
        return axios.post(`/urnature/URNATURESERVICE/user/gate/urnature/userDetailsInfo/addUserDetailsInfo`)
    },

    /**
     * 获取此次问卷答题奖励
     */
    getReward(userId) {
        return axios.get(`/urnature/MOMENTAASSESSMENTSERVICE/user/gate/momentaryassessment/questionnaire/getAnswerBonus?userId=${userId}`)
    },

    /**
     * 保存问卷答题结果
     */
    saveAnswer(latitude, longitude, result, taskResult, userId, photoFile, audioFile) {
        let formData = new FormData();
        formData.append('questionnaireImage', photoFile)
        formData.append('questionnaireAudio', audioFile)
        let obj = { latitude, longitude, taskResult, userId, responsePlatform:'android'}
        let param = qs.stringify(obj)
        return axios.post(`/urnature/MOMENTAASSESSMENTSERVICE/user/gate/momentaryassessment/questionnaire/addQuestionAnswer?${param}&result=${result}`, formData)
    },

    /**
     * 获取用户电话
     */
    getUserPhone() {
        return axios.get(`/urnature/HAPLATUSERSERVICE/haplatuser/v1/user/gate/getNewUserInfo`)
    },

    /**
     * 保存问卷建议
     */
    saveAdvice(phone, suggestion, userName) {
        let form = {
            phone: phone,
            questionnaireId: 2,
            suggestion: suggestion,
            userName: userName
        }
        return axios.post(`/urnature/MOMENTAASSESSMENTSERVICE/user/gate/momentaryassessment/questionnaire/addQuestionnaireSuggestion`, form)
    },

    /**
     * 获取本周统计结果
     */
    getStatistics(userId) {
        return axios.get(`/urnature/MOMENTAASSESSMENTSERVICE/user/gate/momentaryassessment/questionnaire/statistics?userId=${userId}`)
    },

    /**
     * 获取用户详细信息
     */
    getUserDetail(userId) {
        return axios.get(`/urnature/URNATURESERVICE/user/gate/urnature/userDetailsInfo/getByUserId?userId=${userId}`)
    },

    /**
     * 判断今天答题是否不超过10次
     * @returns <[flag1,flag2,flag3,flag4,flag5]>
     * flag1:每日最多两次答题，每次答题需间隔三分钟。 无限制-0；答题超过两次-1；未到答题间隔-2；
     * flag2:是否回答过心理、身体健康状况评价问题。 未回答-0；已回答-1；
     * flag3:是否回答过攻击性问题。 未回答-0；已回答-1；
     * flag4:两周内是否进行过"周问卷”。 未进行过-0；进行过-1
     * flag5: 是否需要展示任务评价 0-不需要 1-需要
     */
    isLessTen(userId) {
        return axios.get(`/urnature/MOMENTAASSESSMENTSERVICE/user/gate/momentaryassessment/questionnaire/judgeAnswerNumber?userId=${userId}`)
    },

    /**
     * 判断用户近三个月内是否确认过用户须知
     * @param userId 用户id
     * @returns false:未确认，true:已确认
     */
    isCheckedNotice(userId) {
        return axios.get(`/urnature/URNATURESERVICE/user/gate/urnature/userDetailsInfo/hasConfirmedUserNotice?questionnaireId=2&userId=${userId}`)
    },


    /**
     * 更新用户确认用户须知的时间
     * @param userId
     */
    updateCheckedTime(userId) {
        return axios.put(`/urnature/URNATURESERVICE/user/gate/urnature/userDetailsInfo/updateUserNoticeConfirmedTime?questionnaireId=2&userId=${userId}`)
    },

    /**
     * 保存任务评价内容
     * @param {*} userId
     * @param {*} completed 是否完成任务0-未完成；1-部分完成；2完成
     * @param {*} evaluation 评价
     * @returns
     */
    saveTaskEvaluation(userId, completed, evaluation) {
        return axios.put(`/urnature/MOMENTAASSESSMENTSERVICE/user/gate/momentaryassessment/questionnaire/completeTask?userId=${userId}&completed=${completed}&evaluation=${evaluation}`)
    }

}
export default questionnaire
